import React from "react"

import { Link } from "gatsby"

import * as styles from "./base-button.module.css"

const BaseButton = ({
  id = "",
  children,
  disabled = false,
  variant = "primary",
  className = "",
  onClick = () => {},
  type = "button",
  to = "",
  size = "md",
  icon = null,
  blank = false,
  ...props
}) => {
  let typeClass = "primary"
  switch (variant) {
    case "primary":
      typeClass = styles.primary
      break
    case "primary-outline":
      typeClass = styles.primaryOutline
      break
    case "secondary":
      typeClass = styles.secondary
      break
    case "accent":
      typeClass = styles.accent
      break
    case "brand-legacy":
      typeClass = styles.brandLegacy
      break
    case "success":
      typeClass = styles.success
      break
    case "danger":
      typeClass = styles.danger
      break
    case "danger-outline":
      typeClass = styles.dangerOutline
      break
    case "tertiary":
      typeClass = styles.tertiary
      break
    case "link-button":
      typeClass = styles.linkButton
      break
    default:
      typeClass = styles.primary
      break
  }

  let sizeClass = styles.md
  switch (size) {
    case "sm":
      sizeClass = styles.sm
      break
    case "md":
      sizeClass = styles.md
      break
    case "lg":
      sizeClass = styles.lg
      break
    default:
      sizeClass = styles.md
      break
  }

  if (type === "external") {
    return (
      <a
        href={to}
        className={`btn ${styles.button} ${typeClass} ${sizeClass} ${className}`}
        data-variant={variant}
        disabled={disabled}
        target={blank ? "_blank" : "_self"}
        rel={blank ? "noreferrer" : ""}
        {...props}
      >
        {icon}
        {children}
      </a>
    )
  }

  if (type === "link") {
    return (
      <Link
        to={to}
        className={`btn ${styles.button} ${typeClass} ${sizeClass} ${className}`}
        data-variant={variant}
        disabled={disabled}
        target={blank ? "_blank" : "_self"}
        {...props}
      >
        {icon}
        {children}
      </Link>
    )
  }

  return (
    <button
      id={id}
      className={`btn ${styles.button} ${typeClass} ${sizeClass} ${className}`}
      data-variant={variant}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {icon}
      {children}
    </button>
  )
}

export default BaseButton
